<template>
  <div class="rounded bg-grey_3 pa-3 my-3 pack_item bordered">
    <div class="d-flex flex-wrap justify-space-between flex-md-nowrap content_pack_item">
      <div>
        <div class="d-flex justify-start flex-wrap gap">
          <h5 class="font-weight-bold">
            {{ pack.nom }}
          </h5>
        </div>
        <div class="d-flex flex-wrap justify-start align-center sm-gap my-1">
          <div class="text-body-2 bg-white px-2 py-1 rounded shadowed" v-for="liaison_course in pack.list_liaisons"
            :key="liaison_course.id"><v-icon icon="mdi-check" color="primary" size="xs-small"></v-icon> {{
              liaison_course.nom_course }}</div>
        </div>
      </div>

      <div class="d-flex flex-column">
        <v-btn
          v-if="(pack_ouvert && mainStore.module.status == 'ouverte') || mainStore.view_as_admin || mainStore.inscription_as_admin"
          class="inscription_btn" color="dark-green " size="default" variant="tonal"
          @click="addToPreselection(pack)"><v-icon icon="mdi-arrow-right-bold" class="mr-2"></v-icon> S'inscrire</v-btn>
        <v-btn v-else class="shadowed" color="dark-red" size="small" variant="tonal"><v-icon
            icon="mdi-pencil-off-outline"></v-icon> Inscriptions closes</v-btn>
        <TarifsPack
          v-if="(pack_ouvert && mainStore.module.status == 'ouverte') || mainStore.view_as_admin || mainStore.inscription_as_admin"
          :pack="pack"></TarifsPack>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import TarifsPack from "@/components/Home/Packs/Tarifs_Pack.vue";
export default {
  props: ["pack"],
  components: { TarifsPack },
  computed: {
    ...mapStores(useMainStore),
    // Vérifie si un pack est ouvert aux inscriptions en fonction des courses dont il dépent.
    pack_ouvert() {
      let courses = this.mainStore.module.courses;
      for (let i = 0; i < this.pack.list_liaisons.length; i++) {
        let liaison = this.pack.list_liaisons[i];
        for (let j = 0; j < courses.list.length; j++) {
          if (courses.list[j].id == liaison.id_course && (courses.list[j].ouvert == "0" || courses.list[j].is_complet(courses))) {

            return false;
          }
        }
      }
      return true;
    },
  },
  methods: {
    /* Si clic sur button _s'inscrire_ on ajoute en mémoire la préselection pour l'ajouter à la sélection de parcours du premier coureur en page suivante */
    addToPreselection(pack) {
      this.mainStore.bookingSystem.preselection = { type: "pack", value: pack.id };
      this.mainStore.bookingSystem.is_inscription_groupe = false;
      this.$router.push({ name: "Inscriptions" });
    },
  },
};
</script>

<style lang="scss" scoped></style>